<template>
    <v-card class="transparent mx-auto my-2 py-2" flat width="400">
         <v-card-text class="text-center">
             <v-icon large color="grey" class="mb-3">{{icon}}</v-icon>
             <h2 class="mb-3">{{text}}</h2>
             <p v-html="description"></p>
         </v-card-text>
          <v-card-text>
             <slot name="content"></slot>
         </v-card-text>
       </v-card>
</template>
<script>

export default {
  props: ['icon','text', 'description'],
   data: () => ({
    
  }),
  computed: {
    
  },
  methods: {
    
  }
}
</script>